<template>
  <section :class="{'gen-toolbar-container': !inline, 'toolbar-inline': inline}">
    <div class="gen-toolbar-box">
      <slot />
    </div>
  </section>
</template>
<script>
export default {
  props: {
    inline: {type: Boolean}
  },
}
</script>
